import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/weaver/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { weaverBaseQuery } from './baseQuery';

const FIVE_MINUTES = 5 * 60;

export const WEAVER_API_REDUCER_PATH = 'api/weaver' as const;

export const weaverApiRoot = createApi({
  reducerPath: WEAVER_API_REDUCER_PATH,
  baseQuery: weaverBaseQuery,
  keepUnusedDataFor: FIVE_MINUTES,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
